import { useMemo } from "react";
import cn from "classnames";
import { RoadSearchCardModel } from "entities/RoadSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import { Line } from "./Line";
import styles from "./LineList.module.scss";

type LineListProps = {
  className?: string;
  data: Nullable<RoadSearchCardModel>;
};

export const LineList: RFC<LineListProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const routes = useMemo(() => data?.routes ?? [], [data?.routes]);
  const hasRoutes = routes.length > 0;

  return (
    <div className={cn(styles["line-list"], !hasRoutes && styles["not-available"], className)}>
      {hasRoutes ? (
        routes.map((route, index) => <Line key={index} data={route} />)
      ) : (
        <>
          <div className={styles["not-available-bold"]}>{t("There is no information about routes at the moment")}</div>
          <div className={styles["not-available-normal"]}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
